export default function StrategyListSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="flex items-center gap-6 bg-white rounded-[48px] p-2 animate-pulse"
        >
          <div className="w-20 h-20 rounded-full bg-[#C7EDEF]" />
          <div className="flex-1">
            <div className="h-5 bg-[#C7EDEF] rounded w-3/4 mb-2" />
            <div className="h-4 bg-[#C7EDEF] rounded w-1/2" />
          </div>
          <div className="w-16 h-16" />
        </div>
      ))}
    </div>
  );
}
